export interface SkuQtyLine {
   sku: string
   qty: number
}

export interface ParsedSkuQtyInput {
   lines: SkuQtyLine[]
   badTokens: string[]
}

/**
 * Découpe une saisie "SKU[*|X]qté, SKU[*|X]qté, …" (insensible à la casse, SKU mis en majuscules).
 * - Un SKU sans quantité vaut 1, sauf s'il est seul : il prend alors `defaultQty` (si > 0).
 * - Une quantité non numérique, nulle ou négative place le token dans `badTokens` (et pas dans `lines`).
 */
export function parseSkuQtyInput(raw: string | null | undefined, defaultQty: number = 1): ParsedSkuQtyInput {
   const tokens = (raw ?? '').toUpperCase().split(',').map(t => t.trim()).filter(Boolean)
   const lines: SkuQtyLine[] = []
   const badTokens: string[] = []
   const singleQty = Number.isFinite(defaultQty) && defaultQty > 0 ? defaultQty : 1
   for (const token of tokens) {
      const parts = token.split(/[X*]/)
      const sku = parts[0].trim()
      const qtyStr = parts[1]?.trim()
      if (qtyStr === undefined || qtyStr === '') {
         lines.push({ sku, qty: tokens.length === 1 ? singleQty : 1 })
         continue
      }
      const n = Number(qtyStr)
      if (!Number.isFinite(n) || n <= 0) {
         badTokens.push(token)
         continue
      }
      lines.push({ sku, qty: n })
   }
   return { lines, badTokens }
}
